import { GlobalHeader } from '@design-system/global-header';
import React from 'react';

import { useAutocomplete } from '~/hooks/useAutocomplete';
import { UseLanguageSwitchHook } from '~/hooks/useLanguageSwitch';
import { headerMapper } from '~/mappers/header';
import {
  HeaderBasic,
  HeaderSplitterAdditionalData,
  HeaderWithSplitter,
} from '~/mappers/header/models';
import { gtmService } from '~/services/gtm';

const HeaderWrap = ({
  headerBasic,
  headerWithSplitter,
  headerSplitterAdditionalData,
  languageSwitch,
}: {
  headerBasic?: HeaderBasic | null;
  headerWithSplitter?: HeaderWithSplitter | null;
  headerSplitterAdditionalData?: HeaderSplitterAdditionalData;
  languageSwitch: ReturnType<UseLanguageSwitchHook>;
}) => {
  const { autocompleteState, getInputProps } = useAutocomplete();

  const mapped = headerMapper({
    headerBasic,
    headerWithSplitter,
    headerSplitterAdditionalData,
    languageSwitch,
  });

  return mapped ? (
    <GlobalHeader
      {...{
        ...mapped,
        profile: undefined,
        search: mapped.search
          ? {
              ...mapped.search,
              autocomplete: { autocompleteState, getInputProps },
            }
          : undefined,
        onClickNavItem: (value) => gtmService.emitHeaderMenuClick(value),
      }}
    />
  ) : null;
};

export default HeaderWrap;
